import { defineMessages } from "react-intl";

export const messages = defineMessages({
  headerOrder: {
    id: "6u4K7e",
    defaultMessage: "Order",
    description: "page header",
  },
  headerOrderNumber: {
    id: "kPIZ65",
    defaultMessage: "Order #{orderNumber}",
    description: "page header",
  },
  headerOrderNumberAddFulfillment: {
    id: "CJpx4E",
    defaultMessage: "Order no. {orderNumber} - Add Fulfillment",
    description: "page header",
  },
  submitFulfillment: {
    id: "BLX9dz",
    defaultMessage: "Fulfill",
    description: "fulfill order, button",
  },
  submitPrepareFulfillment: {
    id: "Uh9R9m",
    defaultMessage: "Prepare fulfillment",
    description: "prepare order fulfillment, button",
  },
  itemsReadyToShip: {
    id: "N5UuEK",
    defaultMessage: "Items ready to ship",
    description: "header",
  },
  productName: {
    id: "vW3tb6",
    defaultMessage: "Product name",
    description: "name",
  },
  sku: {
    id: "fw+VAN",
    defaultMessage: "SKU",
    description: "product's sku",
  },
  quantityToFulfill: {
    id: "Kg0Fiu",
    defaultMessage: "Quantity to fulfill",
    description: "quantity of fulfilled products",
  },
  quantity: {
    defaultMessage: "Quantity",
    id: "0mhR+F",
    description: "Header row quantity label",
  },
  stock: {
    defaultMessage: "Stock",
    id: "tZnV8L",
    description: "Header row stock label",
  },
  noStock: {
    id: "z9wQ/U",
    defaultMessage: "No Stock",
    description: "no variant stock in warehouse",
  },
  sentShipmentDetails: {
    id: "0VDwAP",
    defaultMessage: "Send shipment details to customer",
    description: "checkbox label",
  },
  shipmentInformation: {
    defaultMessage: "Shipment information",
    id: "lF+VJQ",
    description: "Shipment information card header",
  },
  warehouse: {
    defaultMessage: "Warehouse",
    id: "J0lNnk",
    description: "column label",
  },
});
